module.exports = __webpack_public_path__ + "static/media/FeedbackBot.903555eb.xcf";